"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var idm_authorization_client_js_1 = require("@synisys/idm-authorization-client-js");
var login_guard_service_1 = require("../../services/login-guard.service");
exports.shellRoutes = [
    {
        path: 'categories',
        loadChildren: '@synisys/idm-category-manager-ui#CategoryManagerModule',
        canActivate: [login_guard_service_1.LoginGuard, idm_authorization_client_js_1.PermissionGuard],
        data: {
            permissionKey: ['6c081221-9011-11e6-821f-0050568f767f'],
            preload: true
        }
    },
    {
        path: 'pages',
        loadChildren: '@synisys/idm-page-controls#PagesModule',
        canActivate: [login_guard_service_1.LoginGuard, idm_authorization_client_js_1.PermissionGuard],
        data: {
            permissionKey: [],
            preload: true
        }
    },
    {
        path: 'personal-pages',
        loadChildren: '@synisys/idm-page-controls#PersonalPagesModule',
        canActivate: [login_guard_service_1.LoginGuard, idm_authorization_client_js_1.PermissionGuard],
        data: {
            permissionKey: [],
            preload: true,
            isPersonal: true
        }
    },
    // { //TODO 'new page' routing
    // 	path: 'pages/new',
    // 	loadChildren: '@synisys/idm-dynamic-layout-designer/app/page-builder.module#PageBuilderModule',
    // 	canActivate: [LoginGuard, PermissionGuard],
    // 	data: {
    // 		permissionKey: []
    // 	}
    // },
    {
        path: 'me/result-areas',
        loadChildren: '@synisys/idm-me-ui#NameTemplatesListModule',
        canActivate: [login_guard_service_1.LoginGuard, idm_authorization_client_js_1.PermissionGuard],
        data: {
            permissionKey: ['21731f7e-f90a-42c6-bfc4-7b9a7c41fd4a'],
            preload: true
        }
    },
    {
        path: 'me/disaggregates',
        loadChildren: '@synisys/idm-me-ui#DisaggregationManagerModule',
        canActivate: [login_guard_service_1.LoginGuard, idm_authorization_client_js_1.PermissionGuard],
        data: {
            permissionKey: ['e6917466-8b88-49bb-a176-949c0422c5f4'],
            preload: true
        }
    },
    {
        path: 'me/disaggregates/:id',
        loadChildren: '@synisys/idm-me-ui#DisaggregationEditModule',
        canActivate: [login_guard_service_1.LoginGuard, idm_authorization_client_js_1.PermissionGuard],
        data: {
            permissionKey: ['e6917466-8b88-49bb-a176-949c0422c5f4'],
            preload: true
        }
    },
    {
        path: 'me/questionnaires',
        loadChildren: '@synisys/idm-me-ui#QuestionManagerModule',
        canActivate: [login_guard_service_1.LoginGuard, idm_authorization_client_js_1.PermissionGuard],
        data: {
            permissionKey: ['cde06b17-5f75-4714-ae2c-fe916a862341'],
            preload: true
        }
    },
    {
        path: 'me/questionnaires/:id',
        loadChildren: '@synisys/idm-me-ui#QuestionEditModule',
        canActivate: [login_guard_service_1.LoginGuard, idm_authorization_client_js_1.PermissionGuard],
        data: {
            permissionKey: ['cde06b17-5f75-4714-ae2c-fe916a862341'],
            preload: true
        }
    },
    {
        path: 'me/indicators',
        loadChildren: '@synisys/idm-me-ui#IndicatorManagerModule',
        canActivate: [login_guard_service_1.LoginGuard, idm_authorization_client_js_1.PermissionGuard],
        data: {
            permissionKey: ['ee15dcb3-418e-47c1-aea5-6a1b4ce5ef39'],
            preload: true
        }
    },
    {
        path: 'me/data-point',
        loadChildren: '@synisys/idm-me-ui#DataPointManagerModule',
        canActivate: [login_guard_service_1.LoginGuard, idm_authorization_client_js_1.PermissionGuard],
        data: {
            permissionKey: ['818ea1b8-f021-4e01-ba6d-7e3cae03a859'],
            preload: true
        }
    },
    {
        path: 'me/indicator/portfolio/dynamic-de',
        loadChildren: '@synisys/idm-me-ui#IndicatorFormModule',
        canActivate: [login_guard_service_1.LoginGuard, idm_authorization_client_js_1.PermissionGuard],
        data: {
            permissionKey: ['ee15dcb3-418e-47c1-aea5-6a1b4ce5ef39'],
            preload: true
        }
    },
    {
        path: 'me/indicator-templates',
        loadChildren: '@synisys/idm-me-ui#WrapperIndicatorTemplatesModule',
        canActivate: [login_guard_service_1.LoginGuard],
        data: {
            permissionKey: ['b6a2d7d6-458e-4e64-acc0-1ad0a41e4e39'],
            preload: true
        }
    },
    {
        path: 'me/frameworks',
        loadChildren: '@synisys/idm-me-ui#SisFrameworkModule',
        canActivate: [login_guard_service_1.LoginGuard, idm_authorization_client_js_1.PermissionGuard],
        data: {
            permissionKey: ['6cdd6bb9-d2b1-4644-b400-7ee6ebf4165c'],
            preload: true
        }
    },
    {
        path: 'me/corporate-frameworks',
        loadChildren: '@synisys/idm-me-ui#SisLogframeModule',
        canActivate: [login_guard_service_1.LoginGuard, idm_authorization_client_js_1.PermissionGuard],
        data: {
            permissionKey: ['6cdd6bb9-d2b1-4644-b400-7ee6ebf4165c'],
            preload: true
        }
    },
    {
        path: 'me/forms',
        loadChildren: '@synisys/idm-me-ui#MEFormManagementModule',
        canActivate: [login_guard_service_1.LoginGuard, idm_authorization_client_js_1.PermissionGuard],
        data: {
            permissionKey: ['93eae1cd-932d-4a94-baa0-e0aad5bdc891'],
            preload: true
        }
    },
    {
        path: 'um/users',
        loadChildren: '@synisys/idm-um-ui#UserModule',
        canActivate: [login_guard_service_1.LoginGuard, idm_authorization_client_js_1.PermissionGuard],
        data: {
            permissionKey: [
                '2a591221-9041-11e6-821f-0050568f767f',
                '2a991221-9041-11e6-821f-0050568f767f',
                '3a991221-9041-11e6-821f-0050568f767f',
                '2a791222-9041-11e6-821f-0050568f767f'
            ],
            preload: true
        }
    },
    {
        path: 'um/groups',
        loadChildren: '@synisys/idm-um-ui#GroupModule',
        canActivate: [login_guard_service_1.LoginGuard, idm_authorization_client_js_1.PermissionGuard],
        data: {
            permissionKey: [
                '2a891221-9041-11e6-821f-0050568f767f',
                '3a691221-9041-11e6-821f-0050568f767f',
                '3a591221-9041-11e6-821f-0050568f767f',
                '2a491221-9041-11e6-821f-0050568f767f'
            ],
            preload: true
        }
    },
    {
        path: 'um/roles',
        loadChildren: '@synisys/idm-um-role-ui#RoleModule',
        canActivate: [login_guard_service_1.LoginGuard, idm_authorization_client_js_1.PermissionGuard],
        data: {
            permissionKey: [
                '2a691221-9041-11e6-821f-0050568f767f',
                '3a891221-9041-11e6-821f-0050568f767f',
                '3a791221-9041-11e6-821f-0050568f767f',
                '2a391221-9041-11e6-821f-0050568f767f'
            ],
            preload: true
        }
    },
    {
        path: 'um/organizations',
        loadChildren: '@synisys/idm-um-organization-ui#OrganizationModule',
        canActivate: [login_guard_service_1.LoginGuard, idm_authorization_client_js_1.PermissionGuard],
        data: {
            permissionKey: ['2a291221-9041-11e6-821f-0050568f767f'],
            preload: true
        }
    },
    {
        path: 'userprofile',
        loadChildren: '@synisys/idm-user-data-ui#UserProfileModule',
        canActivate: [login_guard_service_1.LoginGuard],
        data: {
            preload: true
        }
    },
    {
        path: 'configurations/templates',
        loadChildren: '@synisys/idm-notification-ui#NotificationTemplatesModule',
        canActivate: [login_guard_service_1.LoginGuard, idm_authorization_client_js_1.PermissionGuard],
        data: {
            permissionKey: ['3b591221-9041-11e6-821f-0050568f767f'],
            preload: true
        }
    },
    {
        path: 'configurations/export-templates',
        loadChildren: '@synisys/idm-ui-export-templates#ExportTemplatesModule',
        canActivate: [login_guard_service_1.LoginGuard, idm_authorization_client_js_1.PermissionGuard],
        data: {
            permissionKey: ['e18fdcc3-c446-461c-ab14-083b83340c53'],
            preload: true
        }
    },
    {
        path: 'configurations/sms',
        loadChildren: '@synisys/idm-sms-service-config-ui#SmppModule',
        canActivate: [login_guard_service_1.LoginGuard, idm_authorization_client_js_1.PermissionGuard],
        data: {
            permissionKey: ['8f113c1a-d253-4aec-8f37-5ea95d38ae1e'],
            preload: true
        }
    },
    {
        path: 'configurations/smtp',
        loadChildren: '@synisys/idm-mail-service-config-ui#SmtpModule',
        canActivate: [login_guard_service_1.LoginGuard, idm_authorization_client_js_1.PermissionGuard],
        data: {
            permissionKey: ['8e113c1a-d253-4aec-8f37-5ea95d38ae1e'],
            preload: true
        }
    },
    {
        path: 'configurations/jobs',
        loadChildren: '@synisys/job-manager-service-ui#JobManagerServiceUiModule',
        canActivate: [login_guard_service_1.LoginGuard, idm_authorization_client_js_1.PermissionGuard],
        data: {
            permissionKey: ['ea1bd63f-df56-4adb-be56-3fdef9a0fe1f'],
            preload: true
        }
    },
    {
        path: 'notifications',
        loadChildren: '@synisys/idm-notification-ui#NotificationsModule',
        canActivate: [login_guard_service_1.LoginGuard],
        data: {
            preload: true
        }
    },
    {
        path: 'page-management',
        loadChildren: '@synisys/idm-page-controls#PageManagementModule',
        canActivate: [login_guard_service_1.LoginGuard, idm_authorization_client_js_1.PermissionGuard],
        data: {
            permissionKey: ['c2a3534e-5382-4b7d-ac31-86d8d77b52fa']
        }
    },
    {
        path: 'monitoring',
        loadChildren: '@synisys/idm-monitoring-ui#MonitoringModule',
        canActivate: [login_guard_service_1.LoginGuard, idm_authorization_client_js_1.PermissionGuard],
        data: {
            permissionKey: ['2eed8d4c-b0b4-458b-aec1-1c442efd2a6b'],
            preload: true
        }
    },
    {
        path: 'policies',
        loadChildren: '@synisys/idm-policy-ui#PolicyModule',
        canActivate: [login_guard_service_1.LoginGuard, idm_authorization_client_js_1.PermissionGuard],
        data: {
            permissionKey: ['1c2f7348-aec7-4b0f-964b-4bbd77b5f4f4'],
            preload: true
        }
    },
    {
        path: 'dynamic-de',
        loadChildren: '@synisys/idm-ui-shell/app/modules/dynamic-forms/de-dynamic-forms.module#DeDynamicFormsModule',
        canActivate: [login_guard_service_1.LoginGuard]
    },
    {
        path: ':level1/dynamic-de',
        loadChildren: '@synisys/idm-ui-shell/app/modules/dynamic-forms/de-dynamic-forms.module#DeDynamicFormsModule',
        canActivate: [login_guard_service_1.LoginGuard]
    },
    {
        path: ':level1/:level2/dynamic-de',
        loadChildren: '@synisys/idm-ui-shell/app/modules/dynamic-forms/de-dynamic-forms.module#DeDynamicFormsModule',
        canActivate: [login_guard_service_1.LoginGuard]
    },
    {
        path: 'audit',
        loadChildren: '@synisys/idm-audit-controls#AuditTrailModule',
        canActivate: [login_guard_service_1.LoginGuard, idm_authorization_client_js_1.PermissionGuard],
        data: {
            permissionKey: ['83f30cc4-0e08-49ed-a997-72fbf18736ac'],
            preload: true
        }
    },
    {
        path: 'configurations/forms',
        loadChildren: '@synisys/idm-ui-shell/app/modules/dynamic-forms/dynamic-form-management.module#DynamicFormManagementModule',
        canActivate: [login_guard_service_1.LoginGuard, idm_authorization_client_js_1.PermissionGuard],
        data: {
            permissionKey: ['2613900a-51ef-48b8-ab66-3aa4e67ed3ed']
        }
    },
    {
        path: 'workflow-management',
        loadChildren: '@synisys/idm-workflow-designer#WorkflowDesignerModule',
        canActivate: [login_guard_service_1.LoginGuard, idm_authorization_client_js_1.PermissionGuard],
        data: {
            permissionKey: ['bfc6afd3-0b6b-4087-bf3c-b6896b727cdf']
        }
    },
    {
        path: 'survey',
        loadChildren: '@synisys/idm-survey-ui#SurveyUiModule',
        canActivate: [login_guard_service_1.LoginGuard, idm_authorization_client_js_1.PermissionGuard],
        data: {
            permissionKey: ['a6634204-0c68-42b1-85e5-d1a7260d305a']
        }
    },
    {
        path: 'dictionary',
        loadChildren: '@synisys/idm-ui-dictionary#DictionaryModule',
        canActivate: [login_guard_service_1.LoginGuard, idm_authorization_client_js_1.PermissionGuard],
        data: {
            permissionKey: ['73ffa0bd-868f-4e5e-8215-e7055d9701e5'],
            preload: true
        }
    },
    {
        path: 'business-process',
        loadChildren: '@synisys/idm-event-handler-ui#EventHandlerModule',
        canActivate: [login_guard_service_1.LoginGuard, idm_authorization_client_js_1.PermissionGuard],
        data: {
            permissionKey: ['2ae82f7e-29e1-4279-9ea5-1b9e6ca406e0', '313dc9b0-b99f-4847-9c01-60aa51ae10e7'],
            preload: true
        }
    },
    {
        path: 'kb',
        loadChildren: '@synisys/idm-kb-builder#KbBuilderModule',
        canActivate: [login_guard_service_1.LoginGuard, idm_authorization_client_js_1.PermissionGuard],
        data: {
            permissionKey: ['c5a0177e-2d25-456d-a041-c00e57593b3b']
        }
    },
    {
        path: 'data-import',
        loadChildren: '@synisys/idm-data-import-ui#DataImportModule',
        canActivate: [login_guard_service_1.LoginGuard, idm_authorization_client_js_1.PermissionGuard],
        data: {
            permissionKey: ['f4efe462-bb75-4893-858d-9c42c4b4cb14'],
            preload: true
        }
    }
];
//# sourceMappingURL=shell.routing.js.map